require.register("modules/m04s/m04s-activity/page-15/page-15", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page15 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page15;

  
});

